import { ColumnDef } from '@tanstack/react-table'
import { Button } from '../../../@/components/ui/button'
import { TrashIcon } from '@heroicons/react/outline'

export type CsvResponse = {
	totalCount: number
	pageSize: number
	skipAmount: number
	hasMore: boolean
	items: Conversation[]
}
type Conversation = {
	id: string
	fileName: string
	createdAt: string
	createdBy: string
	selectedContactsLength: number
}

const formatDate = (date: number) => new Date(date).toLocaleString()

export const columns: ColumnDef<Conversation>[] = [
	{
		accessorKey: 'fileName',
		header: 'Csv Name',
	},
	{
		accessorKey: 'createdAt',
		header: 'Created Timestamp',
		cell: row => formatDate(row.getValue() as number),
	},
	{
		accessorKey: 'createdBy',
		header: 'Created By',
	},
	{
		accessorKey: 'selectedContactsLength',
		header: 'Number of Contacts',
	},
	{
		accessorKey: 'id',
		header: '',
		cell: row => {
			const id = row.getValue() as string

			return (
				<Button
					variant={'ghost'}
					onClick={() => {
						row.table.options.meta?.actions.deleteMutation(id)
					}}
				>
					<TrashIcon className="w-6 h-6 text-gray-500 " />
				</Button>
			)
		},
	},
]
